"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationRulesReviewInputSchema = exports.ImplementationRulesReviewOutputSchema = exports.ImplementationRuleSectionReviewDraftSchema = exports.ImplementationRuleReviewDraftSchema = exports.GroupReviewStateSchema = exports.ExcerptReviewStateSchema = exports.RuleCardStateSchema = exports.ExcerptDecisionSchema = exports.ExcerptDecision = exports.CardVerdictSchema = exports.CardVerdict = exports.DatasheetExcerptCollectionSchema = exports.ExcerptPageSchema = exports.ExcerptSchema = exports.FormulaConfirmationSchema = exports.FormulaConfirmation = exports.ExcerptKindSchema = exports.ExcerptKind = exports.IMPLEMENTATION_RULES_DATASHEET_EXCERPT_VERSION = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const ImplementationRules = require("../../../../ImplementationRules");
const z = require("zod");
exports.IMPLEMENTATION_RULES_DATASHEET_EXCERPT_VERSION = 'v4';
var ExcerptKind;
(function (ExcerptKind) {
    ExcerptKind["Text"] = "text";
    ExcerptKind["TableRow"] = "table_row";
    ExcerptKind["Figure"] = "figure";
    ExcerptKind["Formula"] = "formula";
    ExcerptKind["Table"] = "table";
})(ExcerptKind || (exports.ExcerptKind = ExcerptKind = {}));
exports.ExcerptKindSchema = z.nativeEnum(ExcerptKind);
var FormulaConfirmation;
(function (FormulaConfirmation) {
    FormulaConfirmation["Confirmed"] = "confirmed";
    FormulaConfirmation["Uncertain"] = "uncertain";
    FormulaConfirmation["Unclassified"] = "unclassified";
})(FormulaConfirmation || (exports.FormulaConfirmation = FormulaConfirmation = {}));
exports.FormulaConfirmationSchema = z.nativeEnum(FormulaConfirmation);
exports.ExcerptSchema = z.object({
    id: z.string(),
    pageNumber: z.number().int().positive(),
    kind: exports.ExcerptKindSchema,
    elementIndex: z.number().int().nonnegative(),
    rowIndex: z.number().int().nonnegative().nullable(),
    text: z.string(),
    continuation: z.string().nullable(),
    continuationElementIndex: z.number().int().nonnegative().nullable(),
    matchedSentences: z.string().array(),
    taxon: z.string(),
    figureImage: z.string().nullable(),
    formulaConfirmation: exports.FormulaConfirmationSchema.nullable(),
});
exports.ExcerptPageSchema = z.object({
    pageNumber: z.number().int().positive(),
    title: z.string().nullable(),
});
exports.DatasheetExcerptCollectionSchema = z.object({
    fileId: z.string(),
    excerptVersion: z.string(),
    pages: exports.ExcerptPageSchema.array(),
    excerpts: exports.ExcerptSchema.array(),
});
var CardVerdict;
(function (CardVerdict) {
    CardVerdict["Confirmed"] = "confirmed";
    CardVerdict["Edited"] = "edited";
    CardVerdict["Rejected"] = "rejected";
})(CardVerdict || (exports.CardVerdict = CardVerdict = {}));
exports.CardVerdictSchema = z.nativeEnum(CardVerdict);
var ExcerptDecision;
(function (ExcerptDecision) {
    ExcerptDecision["Dismissed"] = "dismissed";
    ExcerptDecision["RuleCreated"] = "rule_created";
})(ExcerptDecision || (exports.ExcerptDecision = ExcerptDecision = {}));
exports.ExcerptDecisionSchema = z.nativeEnum(ExcerptDecision);
exports.RuleCardStateSchema = z.object({
    verdict: exports.CardVerdictSchema.optional(),
    note: z.string().optional(),
});
exports.ExcerptReviewStateSchema = z.object({
    decision: exports.ExcerptDecisionSchema.optional(),
    ruleIds: z.string().array().optional(),
});
exports.GroupReviewStateSchema = z.object({
    reviewed: z.boolean(),
    auto: z.boolean(),
});
exports.ImplementationRuleReviewDraftSchema = z.object({
    id: z.string(),
    text: z.string(),
    modality: ImplementationRules.RuleModalitySchema.optional(),
    citations: ImplementationRules.RuleCitationSchema.array().optional(),
});
exports.ImplementationRuleSectionReviewDraftSchema = z.object({
    sectionId: z.string(),
    sectionSlug: z.string(),
    rules: exports.ImplementationRuleReviewDraftSchema.array(),
});
exports.ImplementationRulesReviewOutputSchema = z.object({
    excerptVersion: z.string().optional(),
    rules: exports.ImplementationRuleSectionReviewDraftSchema.array().optional(),
    cards: z.record(z.string(), exports.RuleCardStateSchema).optional(),
    excerpts: z.record(z.string(), exports.ExcerptReviewStateSchema).optional(),
    groups: z.record(z.string(), exports.GroupReviewStateSchema).optional(),
    pickedExcerpts: z.record(z.string(), exports.ExcerptSchema).optional(),
    replaceChangedRules: z.boolean().optional(),
});
exports.ImplementationRulesReviewInputSchema = z.object({
    packageId: z.string().min(1),
    datasheetFileId: z.string().min(1),
    manufacturerPartNumber: z.string().min(1),
    signals: sigma_engine_shared_1.DesignModels.SignalSchema.array(),
    implementationRules: ImplementationRules.ImplementationRuleSectionSchema.array(),
    implementationRulesContentHash: z.string().min(1),
});
//# sourceMappingURL=implementation-rules-review.types.js.map